import { render, staticRenderFns } from "./permissions-row.vue?vue&type=template&id=29983706&scoped=true&"
import script from "./permissions-row.vue?vue&type=script&lang=js&"
export * from "./permissions-row.vue?vue&type=script&lang=js&"
import style0 from "./permissions-row.vue?vue&type=style&index=0&id=29983706&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29983706",
  null
  
)

export default component.exports